import { render, staticRenderFns } from "./FilesManage.vue?vue&type=template&id=6b16fc3c&"
import script from "./FilesManage.vue?vue&type=script&lang=js&"
export * from "./FilesManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports